import React from 'react';

import { useRouter } from 'next/router';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';

import { mobile } from '../../styles';

const SportPdpIndicatorWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.moderate}px
    ${({ theme }) => theme.spacing.small}px
    ${({ theme }) => theme.spacing.small}px;
  letter-spacing: 0.3px;
  font-size: 12px;

  ${mobile`
    margin: ${({ theme }) => theme.spacing.moderate}px 0
      ${({ theme }) => theme.spacing.small}px;
  `}
`;

const HeaderText = styled.h4`
  color: ${({ theme }) => theme.colors.default};
  font-size: 12px;
`;

const Paragraph = styled.p`
  color: ${({ theme }) => theme.colors.default};
`;

const StyledLink = styled.a`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.active};
`;

const SportPdpIndicator = () => {
  const router = useRouter();

  const handleRedirect = event => {
    event.preventDefault();
    router.push('/products/bras');
  };
  return (
    <SportPdpIndicatorWrapper>
      <HeaderText>
        <FormattedMessage
          defaultMessage="Sport items are for VIPS only"
          id="site_pdp.sport_items_are_for_vips_only"
        />
      </HeaderText>
      <Paragraph>
        <FormattedMessage
          id="site_pdp.sport_item_pdp_indicator_with_link"
          defaultMessage="{link} to become a VIP today!"
          values={{
            link: (
              <StyledLink onClick={handleRedirect}>
                <FormattedMessage
                  id="site_pdp.sports_link_rb"
                  defaultMessage="Shop our lingerie collection"
                />
              </StyledLink>
            ),
          }}
        />
      </Paragraph>
    </SportPdpIndicatorWrapper>
  );
};

export default SportPdpIndicator;
